import React from "react";
import { useNavigate } from "react-router-dom";
import { CommandDialog, CommandInput, CommandList, CommandItem, CommandGroup, CommandEmpty } from "@/components/ui/command";
import { Users, Building2, GitBranch, Bot, Inbox, BarChart3, Settings, Plus, ClipboardList } from "lucide-react";

export default function CommandPalette({ open, setOpen }) {
  const navigate = useNavigate();
  const go = (p) => { setOpen(false); navigate(p); };
  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <CommandInput placeholder="Jump to..." data-testid="cmd-input" />
      <CommandList>
        <CommandEmpty>No results.</CommandEmpty>
        <CommandGroup heading="Navigate">
          <CommandItem onSelect={() => go("/deals")}><GitBranch className="w-4 h-4 mr-2" />Deals</CommandItem>
          <CommandItem onSelect={() => go("/contacts")}><Users className="w-4 h-4 mr-2" />Contacts</CommandItem>
          <CommandItem onSelect={() => go("/companies")}><Building2 className="w-4 h-4 mr-2" />Companies</CommandItem>
          <CommandItem onSelect={() => go("/agents")}><Bot className="w-4 h-4 mr-2" />Agents</CommandItem>
          <CommandItem onSelect={() => go("/inbox")}><Inbox className="w-4 h-4 mr-2" />Inbox</CommandItem>
          <CommandItem onSelect={() => go("/forms")}><ClipboardList className="w-4 h-4 mr-2" />Forms</CommandItem>
          <CommandItem onSelect={() => go("/analytics")}><BarChart3 className="w-4 h-4 mr-2" />Analytics</CommandItem>
          <CommandItem onSelect={() => go("/settings")}><Settings className="w-4 h-4 mr-2" />Settings</CommandItem>
        </CommandGroup>
        <CommandGroup heading="Create">
          <CommandItem onSelect={() => go("/contacts?new=1")}><Plus className="w-4 h-4 mr-2" />New Contact</CommandItem>
          <CommandItem onSelect={() => go("/deals?new=1")}><Plus className="w-4 h-4 mr-2" />New Deal</CommandItem>
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
}
